import React from 'react';
import MSACanvas from './MSACanvas';
import MSAMouseoverCanvas from './MSAMouseoverCanvas';
export default function MSAPanel({ model }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(MSACanvas, { model: model }),
        React.createElement(MSAMouseoverCanvas, { model: model })));
}
//# sourceMappingURL=index.js.map